<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog">
        <el-form ref="formValidate" :model="model" label-width="120px">
            <el-form-item label="车型：" prop="model_type">
                <span>{{ transEnu(model.model_type, "model_type")}}</span>
            </el-form-item>
            <el-form-item label="电商平台：" prop="shop_platform">
                <span>{{ transEnu(model.shop_platform, "shop_platform")}}</span>
            </el-form-item>
            <el-form-item label="标题：" prop="title">
                <span>{{model.title}}</span>
            </el-form-item>
            <el-form-item label="描述：" prop="ftitle">
                <span>{{model.ftitle}}</span>
            </el-form-item>
            <el-form-item label="链接：" prop="link">
                <span>{{model.link}}</span>
            </el-form-item>
            <el-form-item label="口令：" prop="tpwd">
                <span>{{model.tpwd}}</span>
            </el-form-item>
            <el-form-item label="状态：" prop="state">
                <span>{{ transEnu(model.state, "goods_state")}}</span>
            </el-form-item>
            <el-form-item label="排序：" prop="order_index">
                <span>{{model.order_index}}</span>
            </el-form-item>
            <el-form-item label="图片1：" prop="img1">
                <el-image style="width: 225px; height: 180px" :src="model.img1"></el-image>
            </el-form-item>
            <el-form-item label="图片2：" prop="img2">
                <el-image style="width: 225px; height: 180px" :src="model.img2"></el-image>
            </el-form-item>
            <el-form-item label="图片3：" prop="img3">
                <el-image style="width: 225px; height: 180px" :src="model.img3"></el-image>
            </el-form-item>
            <el-form-item label="添加时间：" prop="add_time">
                <span>{{model.add_time}}</span>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="closeDialog" size="medium">关 闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: 'goodsInfo',
    mixins: [editutil],
    data() {
        return {
            model: {
                model_type: '',
                shop_platform: '',
                title: '',
                ftitle: '',
                link: '',
                tpwd: '',
                img1: '',
                img2: '',
                img3: '',
                order_index: '',
                add_time: '',
            },
            getObj:{
                url:'/api/admin/goodsjd/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: ['goods_state', 'shop_platform', 'model_type'],
        };
    },
    methods: {}
};
</script>